export default __webpack_public_path__ + "static/media/ordrrNewLogo.ed37d383.svg";